import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { EMPTY, map, Observable, take, tap } from "rxjs";
import { normalizeBatches } from "../../helpers/batch-transition/normalize-batches.helper";
import { TicketBatch } from "../modal-tickets/types/ticket-batch.type";
import {
  BatchTransitionDialogData,
  BatchTransitionModalComponent,
} from "./batch-transition-modal.component";

/** Component-scoped facade: each list/summary owns its pending confirmation. */
@Injectable()
export class BatchTransitionDialogFacade {
  private readonly dialog = inject(MatDialog);
  private confirmationPending = false;

  get pending(): boolean {
    return this.confirmationPending;
  }

  open(data: BatchTransitionDialogData): Observable<TicketBatch[] | undefined> {
    if (this.confirmationPending) return EMPTY;
    this.confirmationPending = true;
    return this.dialog
      .open<
        BatchTransitionModalComponent,
        BatchTransitionDialogData,
        TicketBatch[]
      >(BatchTransitionModalComponent, {
        width: "560px",
        maxWidth: "95vw",
        data,
      })
      .afterClosed()
      .pipe(
        take(1),
        tap(() => (this.confirmationPending = false)),
        map((batches) =>
          Array.isArray(batches) ? normalizeBatches(batches) : undefined,
        ),
      );
  }
}
